export default __webpack_public_path__ + "static/media/position.7ee09694.svg";